import { Effect } from 'effect';
import type * as HttpClientResponse from 'effect/unstable/http/HttpClientResponse';

/**
 * Adds HTTP status code to current span after response is received
 */
export const addResponseStatusToSpan = (response: HttpClientResponse.HttpClientResponse) =>
  Effect.annotateCurrentSpan('http.status_code', response.status);
